const barChartValueGetter = (params) => params.data.resultats?.aptitudes;

export default barChartValueGetter;
